
const endpoints = {
  form: '/form',
  post: '/cms/blogs',
  blog: '/cms/blogs/type',
  analytics: "/analytics",
  analyticsUsers: `/analytics/users`,
}

export default endpoints;